import { looseBody } from './utils/fn';

export const dva = {
  config: {
    onError(err) {
      err.preventDefault();
      console.error(err.message);
    },
  },
};

export const onRouteChange = ({ location, routes, action }) => {
  if (action === 'POP') looseBody();
  window.g_app._store.dispatch({
    type: 'user/save',
    payload: {
      pageAction: action,
    },
  });
};
